import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { palette } from 'styled-theme'
import ReactDatePicker from 'react-datepicker'
import { datetimeFormatter } from '../../../utlils/datetime'
import Input from '../../atoms/Input'

import 'react-datepicker/dist/react-datepicker.css'

const StyledWrapper = styled.div`
  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker {
    border: 1px solid ${palette('primary', 0)};
    box-shadow: 0 1px 5px 2px ${palette('primary', 5)};
  }

  .react-datepicker__header {
    background-color: ${palette('primary', 5)};
    border-bottom: 1px solid ${palette('primary', 0)};
  }

  .react-datepicker__current-month {
    font-size: 1.125rem;
  }

  .react-datepicker__close-icon::after {
    background-color: transparent;
    font-size: 2rem;
    color: ${palette('primary', 0)};
    width: 2rem;
    height: 2rem;
  }

  .react-datepicker__triangle {
    stroke: ${palette('primary', 0)};
  }
  .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {
    fill: ${palette('primary', 5)};
    color: ${palette('primary', 5)};
  }

  .react-datepicker__day--selected {
    background-color: ${palette('primary', 0)};
    :not([aria-disabled=true]):hover {
      background-color: ${palette('primary', 2)};
    } 
  }

  .react-datepicker__navigation-icon::before {
    border-color: ${palette('grayscale', 3)};
  }
  .react-datepicker__navigation:hover {
    .react-datepicker__navigation-icon::before {
      border-color: ${palette('primary', 2)};
    }
  }
  .react-datepicker__year-read-view  {
    .react-datepicker__year-read-view--down-arrow {
      border-color: ${palette('grayscale', 3)};
    }
    :hover {
      .react-datepicker__year-read-view--down-arrow {
        border-color: ${palette('primary', 2)};
      }
    }
  }

  .react-datepicker__year-read-view--selected-year {
    font-size: 1rem;
  }
  .react-datepicker__year-dropdown {
    height: auto;
    max-height: 300px;
  }
  .react-datepicker__year-option {
    font-size: 1rem;
    padding: 6px 0;
  }

  .react-datepicker__day-name, .react-datepicker__day, .react-datepicker__time-name {
    font-size: 1rem;
  }
`

class CustomInput extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    return <Input {...this.props} inputMode="numeric" />
  }
}

const DatePicker = ({ value, onChange, placeholder, inputProps, ...props }) => {
  const onDateChange = useCallback((date) => {
    if (date && date instanceof Date) {
      return onChange(datetimeFormatter(date, 'YYYY-MM-DD'))
    }
    return onChange(null)
  }, [onChange])

  return (
    <StyledWrapper>
      <ReactDatePicker
        selected={value}
        customInput={<CustomInput {...inputProps} />}
        onChange={onDateChange}
        dateFormat="yyyy-MM-dd"
        placeholderText={placeholder}
        showYearDropdown
        scrollableYearDropdown
        yearDropdownItemNumber={100}
        isClearable
        {...props}
      />
    </StyledWrapper>
  )
}

DatePicker.propTypes = {
  value: PropTypes.string, // YYYY-MM-DD
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  inputProps: PropTypes.object,
}

DatePicker.defaultProps = {
  value: null,
  onChange: () => {},
  placeholder: null,
  inputProps: {},
}

export default DatePicker
